module.exports = __webpack_public_path__ + "static/users-fa98dd9bb8b4b5ff0eab82ee814e0df0.svg";